import { render } from "./DynamicCourseDetails.vue?vue&type=template&id=6c349c7a"
import script from "./DynamicCourseDetails.vue?vue&type=script&lang=js"
export * from "./DynamicCourseDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__